import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { firstValueFrom } from 'rxjs';
import { SubscriptionService } from './subscription.service';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class ExcelService {

  constructor(
    private subscriptionService: SubscriptionService  // ✅ new
  ) {}

  async exportJobLogs(
    jobId:         string,
    logs:          any[],
    getWorkerName: (id: string) => string
  ): Promise<void> {

    // ✅ Check plan before exporting
    try {
      const sub = await firstValueFrom(
        this.subscriptionService.loadCurrent()
      );

      if (!sub.limits.hasExcelExport) {
        await Swal.fire({
          title:             'Excel Export Locked',
          html: `
            <p style="color:#374151; font-size:14px;">
              Excel export is not available on the
              <strong>${sub.plan}</strong> plan.<br/><br/>
              Upgrade to <strong>Starter</strong> or higher to export Excel reports.
            </p>`,
          icon:              'warning',
          confirmButtonText: 'View Pricing',
          showCancelButton:  true,
          cancelButtonText:  'Cancel',
          confirmButtonColor: '#2BB0A6',
          cancelButtonColor:  '#6B7280',
          customClass: { popup: 'swal-fieldops' }
        }).then(result => {
          if (result.isConfirmed)
            window.location.href = '/pricing';
        });
        return;  // ✅ stop export
      }
    } catch { /* fail open — allow export on network error */ }

    // ✅ Proceed with export
    const data = logs.map(log => ({
      Worker:     getWorkerName(log.userId),
      JobId:      jobId,
      WorkDone:   log.workDone || log.notes || '',
      Hours:      log.hoursSpent,
      Date:       new Date(log.createdUtc).toLocaleString(),
      Latitude:   log.latitude  ?? '',
      Longitude:  log.longitude ?? '',
      PhotoCount: log.photos?.length || 0
    }));

    // ✅ Totals row
    data.push({
      Worker:     'TOTAL',
      JobId:      '',
      WorkDone:   '',
      Hours:      logs.reduce((sum, l) => sum + (l.hoursSpent || 0), 0),
      Date:       '',
      Latitude:   '',
      Longitude:  '',
      PhotoCount: logs.reduce((sum, l) => sum + (l.photos?.length || 0), 0)
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    worksheet['!cols'] = [
      { wch: 20 },  // Worker
      { wch: 38 },  // JobId
      { wch: 50 },  // WorkDone
      { wch: 8  },  // Hours
      { wch: 22 },  // Date
      { wch: 14 },  // Latitude
      { wch: 14 },  // Longitude
      { wch: 12 },  // PhotoCount
    ];

    const workbook: XLSX.WorkBook = {
      Sheets:     { 'Logs': worksheet },
      SheetNames: ['Logs']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type:     'array'
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    saveAs(blob, `job-${jobId}-logs.xlsx`);
  }
}